import { Flex, SimpleGrid, Box } from "@chakra-ui/layout";

import CardMoradores from "./components/CardMoradores";
import CardAcordos from "./components/CardAcordos";
import CardReceitas from "./components/CardReceitas";
import CardSaldo from "components/Cards/CardSaldo";

import DashboardHeader from "./components/DashboardHeader";
import WithPermission from "components/WithPermission";
import useHasPermission from "features/permissions/hooks/useHasPermission";
import { permissionsFor } from "./util";
import Container from "components/Container";
import CardReservaSubtenants from "./components/Subtenants/CardReserva";
import CardManutencaoSubtenants from "./components/Subtenants/CardManutencoes";

function DashboardSubtenants() {
  const hasPermissionDashboard = useHasPermission(permissionsFor.Dashboard);

  return (
    <>
      <Container>
        <Box>
          <Flex flexDir="column">
            <DashboardHeader />

            <SimpleGrid
              columns={{ sm: 2, md: 2, lg: 4 }}
              gap="16px"
              mb={hasPermissionDashboard ? "32px" : undefined}
            >
              <WithPermission permissions={permissionsFor.CardMoradores}>
                <CardMoradores />
              </WithPermission>

              <WithPermission permissions={permissionsFor.CardAcordos}>
                <CardAcordos />
              </WithPermission>

              <WithPermission permissions={permissionsFor.CardReceitas}>
                <CardReceitas />
              </WithPermission>

              <WithPermission permissions={permissionsFor.CardSaldo}>
                <CardSaldo />
              </WithPermission>
            </SimpleGrid>

            <SimpleGrid columns={{ sm: 1, lg: 2 }} gap="16px">
              {/* <WithPermission permissions={permissionsFor.CardMensagens}>
                  <CardMensagens />
                </WithPermission> */}

              <WithPermission permissions={permissionsFor.CardReserva}>
                <CardReservaSubtenants />
              </WithPermission>

              <WithPermission permissions={permissionsFor.CardManutencoes}>
                <CardManutencaoSubtenants />
              </WithPermission>

              {/* <CardAnuncioPendente /> */}

              {/* <CardUnidades /> */}
            </SimpleGrid>
          </Flex>
        </Box>
      </Container>
    </>
  );
}

export default DashboardSubtenants;
